import React from 'react'
import { Button, Table } from 'react-bootstrap'
import { Edit, Trash } from 'react-feather'

const VendorList = ({ vendorData, handleEdit, handleDelete }) => {
    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Code</th>
                        <th>Vendor Name</th>
                        <th>Location</th>
                        <th>Contact Number</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {vendorData.map((data, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{data.code}</td>
                            <td style={{textTransform:'capitalize'}}>{data.name}</td>
                            <td>{data.location}</td>
                            <td>{data.contact_number}</td>
                            <td>
                                <div className="d-flex gap-2">
                                    <Button variant='warning' size='sm' onClick={() => handleEdit(data)}><Edit size={14} /></Button>
                                    {/* <Button variant='danger' size='sm' onClick={() => handleDelete(index)}><Trash size={14} /></Button> */}
                                </div>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

        </>
    )
}

export default VendorList
